module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"enhanced-tabular-question-context\">\n      <div [innerHtml]=\"question.questionContext.description | mpSafeHtml\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/enhanced-tabular-question-context/enhanced-tabular-question-context.html
// module id = xC7h
// module chunks = 3